import React, { useContext, useEffect, useState } from "react";
import "./OpenProblems.css";
import { useLoading } from "../../../context/loadingContext";
import Pepper from "../../Images/Pepper.png";
import { SiOverleaf } from "react-icons/si";
import { GiMagicLamp } from "react-icons/gi";
import { FaRegFolder } from "react-icons/fa";
import { IoKeyOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import Image from "../../Images/cat.jpg";
import { GettingAllUnits } from "../../../Functions/CRUD/Units/unitsHelper";
import LoadingPage from "../../../Error/LoadingPage/LoadingPage";
import Modal from "./AddNewUnit/Modal";
import { AuthContext } from "../../../context/authContext";
const OpenProblems = () => {
const bookColors = [
    { main: "#7B1E3A", dark: "#4A0F22" }, // crimson
    { main: "#1E3A5F", dark: "#0F1F33" }, // navy
    { main: "#3A5F0B", dark: "#1F3305" }, // olive
    { main: "#5B2C6F", dark: "#32183C" }, // royal purple
    { main: "#8B4513", dark: "#4A240A" }, // brown
    { main: "#2F4F4F", dark: "#172828" }, // dark slate
  ];
  
  
  const {user}=useContext(AuthContext)
  const [Submit, setSubmit] = useState(0);
  const [loading, setloading] = useState(false)
  const [OpenProblemSet, setOpenProblemSet] = useState(null)
  const [showModal, setShowModal] = useState(false);
  const fetchUnits = async () => {
    try {
      setloading(true)
const data = await GettingAllUnits()
      console.log(data)
      setOpenProblemSet(data)
    } catch (err) {
     if (err.response?.status === 404) {
      setOpenProblemSet([]) // not found → return empty array
    }
    } finally {
      setloading(false)
    }
      
  }

  useEffect(()=> {fetchUnits()},[])

  if (loading) {
    return <LoadingPage/>;
  }
 if (!loading && !OpenProblemSet) {
 return (
      <div className="OpenProblems">
        <h1>📚 Open Problems </h1>
        <p className="Purpose">
          <b>Puropose : </b> Here you'll find rich problem sets that tackle a
          specific field at a time . As students you can write you're solutions
          by hand or using a text editor an then submit them as a pdf File to be
          corrected by instructors. As each problem is assigned a set of
          credits, you may level up your score along with your skills and grant
          yourself a badge.
          <br />
          After submitting a unit, it's marked ⏳ and queued; once approved, it
          becomes ✅ (you can access solutions in the meantime). Units to work
          on are marked 🌠.
        </p>{" "}
        <p className="error">No data is available at the moment ...</p>
      </div>
    );
  }

  return (
    <div className="OpenProblems">
      <div className="Intro">
        <h1>📚 Our Library </h1>

        
      </div>

      <Modal showModal={showModal} setShowModal={setShowModal} />
      {/* 📋 💡 📂 🎮 🗝️ */}

      <div className="ProblemSetContainer">
        <div className="OpenProblem-table-container">
          {OpenProblemSet.length === 0 ? (
            <div className="Bookshelf">
              <div className="Book">
              <div className="BookDifficulty">No unit is available</div>
              </div>
              
            </div>
          ) : (
            <div className="Bookshelf">
  {OpenProblemSet?.map((Set,index) => {
    const color = bookColors[index % bookColors.length];
    return (
      <Link
      to={`/OpenProblems/${Set._id}`}
      className="BookLink Book"
      key={Set._id} style={{
        backgroundColor: color.main,
        border: `6px solid ${color.dark}`,
      }}
    >
  

      <div className="BookDifficulty">
        {Array.from({
          length:
            Set?.difficulty === "Hard"
              ? 3
              : Set?.difficulty === "Medium"
              ? 2
              : 1,
        }).map((_, index) => (
          <img key={index} src={Pepper} alt="" />
        ))}
      </div>

      
        <div className="BookTitle">
          {Set.field} — {Set.title}
        </div>
      

  
    </Link>
  )})}
</div>

          )}
        </div>
      </div>
      <p className="Purpose">
          <b>Puropose : </b> Here you'll find rich problem sets that tackle a
          specific field at a time . As students you can write you're solutions
          by hand or using a text editor an then submit them as a pdf File to be
          corrected by instructors. As each problem is assigned a set of
          credits, you may level up your score along with your skills and grant
          yourself a badge.
          <br />
          The units are ranked by level of difficulty, which is indicated by the
          number of peppers each unit shows. The fewer the peppers the easier it
          gets. 🌶️
        </p>

      {user?.role === "Admin" ? (
        <button className="AddUnitBtn" onClick={() => setShowModal(true)}>
          ➕ Add New Unit
        </button>
      ) : null}
    </div>
  );
};
export default OpenProblems;
